// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"2d49f1f3","654":"5f4f9b03","787":"33f4629b"}[chunkId] + ".chunk.js";
};